import type { MapperImageOptions, ModuleMedia } from '#layers/core/types'
import type { IModuleMedia } from '~/types/content-types'
import { mapperImage } from '../../utils/mappers/mapper-image'

export const mapperModuleMedia = (
  data: IModuleMedia,
  imageOptions?: MapperImageOptions | MapperImageOptions[]
): ModuleMedia | ModuleMedia[] | null => {
  if (!data) {
    return null
  }

  return mapWithFrontify(data, imageOptions)
}

const mapWithFrontify = (
  data: IModuleMedia,
  imageOptions?: MapperImageOptions | MapperImageOptions[]
): ModuleMedia | ModuleMedia[] | null => {
  const frontifyAsset = data.frontifyAsset?.[0]
  if (!frontifyAsset || !frontifyAsset.src) {
    console.warn('[MAPPER MODULE MEDIA] Missing asset', data.name)
    return null
  }
  const original = {
    src: frontifyAsset?.src || '',
    alt: data.alt || data.name,
    transform: frontifyAsset?.preview_url || '',
    extension: frontifyAsset?.ext || '',
    name: data.name || '',
    color: data.color || '',
    isPublic: true,
    size: {
      width: frontifyAsset?.width,
      height: frontifyAsset?.height
    },
    focalPoint: frontifyAsset?.focalPoint || null,
    frontifyType: frontifyAsset?.type || '',
    isFrontifyAsset: true
  }
  // when the asset is marked as public we can return the original here (for pdf assets)
  const link = {
    url: frontifyAsset?.generic_url || frontifyAsset?.src || '',
    title: data.name || '',
    download: true,
    nuxt: false,
    openInNewWindow: true
  }

  // No image options provided
  if (!imageOptions) {
    const mappedImage = mapperImage(original)
    if (!mappedImage) return null
    return {
      original,
      link,
      lazy: false,
      source: (data.source as string) || '',
      ...mappedImage,
      contentType: data.contentType
    }
  }

  const resizeImg = (data: IModuleMedia, imageOptions: MapperImageOptions): ModuleMedia | null => {
    const resized = mapperImage(original, imageOptions.sizes, imageOptions.recolor, imageOptions.zoom)
    if (!resized) return null
    return {
      original,
      link,
      lazy: !!imageOptions?.lazy,
      caption: data.caption || '',
      source: data.source || '',
      ...resized,
      contentType: data.contentType
    }
  }

  // If an array of options is passed, we return an array of resized images
  if (Array.isArray(imageOptions)) {
    return imageOptions.flatMap((options) => {
      const resized = resizeImg(data, options)
      if (!resized) return []
      return resized
    })
  }
  // Most common scenario
  return resizeImg(data, imageOptions)
}
